import React from 'react';
import {
  DropDownMenu,
  MenuItem
} from 'material-ui';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { toggleLoading } from 'stores/actions';

const LoginId = 1000;
const StationId = 4000;
let SessionId = '';
const IP = "";
const Password = "";
const Language = "EN";
const LCID = 0;
const NO_ERROR = 0;
let PresenceAgentService;

class CTI extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      status: 'notLoggedIn'
    }
  }

  loginCallback( result, SessionIdResult ) {
    console.log( '----LoginCallback----' );
    console.log( '----LoginCallback result----', result );
    console.log( '----LoginCallback SessionIdResult----', SessionIdResult );
    if( result === NO_ERROR ) {
      console.log( '----LoginCallback ENTRO----' );
      SessionId = SessionIdResult;

      StartCheckEvent( SessionId, this.processEvents );
      this.getSessionInfo();

    } else this.showDialog( 'Error', 'Error when session login:' + result );
  }


  logout() {
    console.log( 'Logout' );
    PresenceAgentService.Logout(
      SessionId,
      100,
      ( result ) => this.logoutCallback( result ),
      this.showError );
  }

  logoutCallback( result ) {
    console.log( 'LogoutCallback' );
    if( result === NO_ERROR ) {
      // stops event recive
      StopCheckEvent();
    } else this.showDialog( 'Error', 'Error when logout session:' + result );
  }

  initializate() {
    console.log( '----initializate----' );
    PresenceAgentService = StartPresenceAgentServices( "http://172.22.249.188/agentws/pcoAgentWS.dll/JSON", false );
    //set global variable
    SessionId = '';
    // Logs in the user agent (Login) to Presence Server
    PresenceAgentService.Login( LoginId, SessionId, Password, StationId, true, '', IP, Language, LCID,
      ( result, SessionIdResult ) => this.loginCallback( result, SessionIdResult ), this.showError );
  }


  processEvents( Events ) {
    console.log( '---ProcessEvents---' );
    console.log( '---ProcessEvents Events---', Events );

    try {
      console.log( '---ProcessEvents TRY---' );
      let numEvents;
      try {
        numEvents = Events.items.length;
      } catch( err ) {
        //avoid failure if no events
        numEvents = 0;
      }

      for( let i = 0; i < numEvents; i++ ) {
        try {
          let Event = Events.items[i];
          let EventType = Event.EventType.value.value;
          let Fields = GetEventFields( Event );
          console.log( '---ProcessEvents TRY EventType---', EventType );
          console.log( '---ProcessEvents TRY Fields---', Fields );
        } catch( err ) {
          console.log( '---ProcessEvents CATCH---', err );
          alert( 'error process events' );
        }
      }
    } finally {
      console.log( '---ProcessEvents FINALLY---' )
    }
  }

  getSessionInfo() {
    console.log( '----getSessionInfo----' );
    PresenceAgentService.GetSessionInfo( SessionId,
      ( result, SessionInfo ) => this.getSessionInfoCallBack( result, SessionInfo ), this.showError )
  }

  getSessionInfoCallBack( result, SessionInfo ) {
    console.log( '----GetSessionInfoCallBack result----', result );
    if( result === NO_ERROR ) {
      console.log( '----GetSessionInfoCallBack SessionInfo----', SessionInfo );
    } else this.showDialog( 'Error', 'Error when Session Info:' + result );
  }

  showError( msg ) {
    console.log( 'showError', msg );
    alert( 'Error: ' + msg.getErrorMessage() );
  }

  showDialog( title, message ) {
    console.log( 'showDialog title', title );
    console.log( 'showDialog message', message );
    alert( title + ': ' + message );
  }


  startSession() {
    console.log( 'startSession' )
    PresenceAgentService.StartSession(
      SessionId,
      this.startSessionCallback,
      this.showError );
  }


  startSessionCallback( result ) {
    console.log( 'startSessionCallback', result )
    if( result === NO_ERROR ) {
      abortCheckEvents = false;
    } else this.showDialog( 'Error', 'Error when start session:' + result );
  }


  stopSession( ) {
    console.log( 'StopSession' );
    PresenceAgentService.StopSession(
      SessionId,
      100,
      this.stopSessionCallback,
      this.showError );
  }

  stopSessionCallback( result ) {
    console.log( 'StopSessionCallback' );
    if( result === NO_ERROR ) {
      //when is stopped we will recive a event
    } else this.showDialog( 'Error', 'Error when stop session:' + result );
  }


  render() {
    return (
      <div className="box-footer p-2" style={{ backgroundColor: '#2e6c99' }}>
        <div className="row text-white">
          <div className="col-md">
            Login in order to attend calls
          </div>
          <div className="col-md-auto font-weight-light">
              <span className="pointer" onClick={this.initializate.bind( this )}>
                <i className="fa fa-sign-in mr-1"/>
                Login
              </span>
            <span className="pointer" onClick={this.startSession.bind( this )}>
                <i className="fa fa-sign-in mr-1"/>
                Start
              </span>
            <span className="pointer" onClick={this.stopSession.bind( this )}>
                <i className="fa fa-sign-in mr-1"/>
                Stop
              </span>
          </div>
        </div>


        <div className="row text-white">
          <div className="col-md">
            <i className="fa fa-headphones mr-1"/>
            <span className="font-weight-bold">Yasef Barban</span>
            {' '}
            <span className="font-weight-light font-italic" onClick={this.logout.bind( this )}>(logout)</span>
          </div>
          <div className="col-md-auto d-flex align-items-center">
            <span className="pr-1">Status:</span>
            <DropDownMenu value={1} underlineStyle={{ borderTop: 0 }} style={{ height: 20 }}
                          labelStyle={{
                            height: 20,
                            lineHeight: '20px',
                            paddingLeft: 0,
                            paddingRight: 20,
                            color: '#42D358',
                            fontWeight: 'normal'
                          }}
                          iconStyle={{ height: 20, width: 20, padding: 0, right: 0, top: -2 }}
                          selectedMenuItemStyle={{ color: 'rgba(0, 0, 0, 0.87)' }}>
              <MenuItem value={1} primaryText="Ready"/>
              <MenuItem value={2} primaryText="Not ready"/>
            </DropDownMenu>
          </div>
        </div>

        <div className="bg-white p-2 mt-2">
          <div className="row align-items-center">
            <div className="col-md">
              <span className="font-weight-bold mr-1">Incoming call:</span>
              <span className="font-italic font-weight-light">lynn wanyama-otieno</span>
              <h5 className="mb-0 mt-1">+34 636 273 223</h5>
            </div>
            <div className="col-md-auto">
              <button type="button"
                      className="btn btn-success text-white btn-fixed-sm mr-1"
                      style={{ backgroundColor: '#42D358', borderColor: '#42D358' }}>
                <i className="icon-phone"/>
              </button>
              <button type="button"
                      className="btn btn-danger text-white btn-fixed-sm"
                      style={{ backgroundColor: '#BB4343', borderColor: '#BB4343' }}>
                <i className="fa fa-phone"/>
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( injectIntl( CTI ) );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/CTI/index.js